import { Navigate } from "react-router-dom";

export const AuthRedirection = () => {
  const storedUserInfo = localStorage.getItem("user");

  if (!!storedUserInfo) {
    return <Navigate replace to="/dashboard/mymeals/" />;
  } else return <Navigate replace to={`/home`} />;
};

export default AuthRedirection;
